import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-calyrafit-slide';

const items = [
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f8931244951c3bb8ce4e.png',
    subTitle: 'Realign & Lift',
    title: 'Posture & Support',
    cta: {
      link: '#',
      text: 'Shop Now',
      icon: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f8d129be3c6ed1534bd6.png',
    },
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f8970d6aadefe8c5ae22.png',
    subTitle: 'Realign & Lift',
    title: 'Posture & Support',
    cta: {
      link: '#',
      text: 'Shop Now',
      icon: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f8d129be3c6ed1534bd6.png',
    },
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f89aea535d06f1256703.png',
    subTitle: 'Realign & Lift',
    title: 'Posture & Support',
    cta: {
      link: '#',
      text: 'Shop Now',
      icon: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f8d129be3c6ed1534bd6.png',
    },
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f89dee2dd4860b3f95f7.png',
    subTitle: 'Realign & Lift',
    title: 'Posture & Support',
    cta: {
      link: '#',
      text: 'Shop Now',
      icon: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f8d129be3c6ed1534bd6.png',
    },
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f8931244951c3bb8ce4e.png',
    subTitle: 'Realign & Lift',
    title: 'Posture & Support',
    cta: {
      link: '#',
      text: 'Shop Now',
      icon: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f8d129be3c6ed1534bd6.png',
    },
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f8970d6aadefe8c5ae22.png',
    subTitle: 'Realign & Lift',
    title: 'Posture & Support',
    cta: {
      link: '#',
      text: 'Shop Now',
      icon: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f8d129be3c6ed1534bd6.png',
    },
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f89aea535d06f1256703.png',
    subTitle: 'Realign & Lift',
    title: 'Posture & Support',
    cta: {
      link: '#',
      text: 'Shop Now',
      icon: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f8d129be3c6ed1534bd6.png',
    },
  },
  {
    image: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f89dee2dd4860b3f95f7.png',
    subTitle: 'Realign & Lift',
    title: 'Posture & Support',
    cta: {
      link: '#',
      text: 'Shop Now',
      icon: 'https://cdn.skyfastimg.com/images/2026/09/22/image-6ab1f8d129be3c6ed1534bd6.png',
    },
  },
];

const renderSlideItem = item => {
  const cta = item.cta || {};
  return `
  <div data-attribute="slide-item" class="swiper-slide">
    <div class="wrap-item">
      <div class="wrap-imge">
        <img data-attribute="item-image" src="${item.image || ''}" alt="" />
      </div>
      <div class="wrap-action-info">
        <div class="wrap-title">
          <div data-attribute="sub-title-item" class="sub-title-item">${item.subTitle || ''}</div>
          <div data-attribute="title-item" class="title-item">${item.title || ''}</div>
        </div>
        <div class="wrap-cta">
          <a href="${cta.link || '#'}" data-attribute="cta-item" class="cta-item">
            <span class="text-cta" data-attribute="text-cta">${cta.text || ''}</span>
            ${cta.icon ? `<img data-attribute="icon-cta" src="${cta.icon}" alt="" />` : ''}
          </a>
        </div>
      </div>
    </div>
  </div>
`;
};

const html = `
<div data-show="true" data-attribute="card-title" class="card-title">
    <h2 style="text-align:center;">Don't Just Take Our <span style="color:hsl( 336, 41%, 48% );"><i>Word For It</i></span></h2>
    <p style="text-align: center;">
      Designed for women who want real comfort, real confidence, and real protection—without bulky. Our advanced fabric
      and smart construction keep you cool, dry, and supported all day.
    </p>
  </div>
  <div class="block-slide swiper">
    <div data-attribute="list-item" class="swiper-wrapper">
      ${items.map(renderSlideItem).join('')}
    </div>
  </div>
`;

export default containerFuild(html, css);
